import { StateCreator } from 'zustand';
import { UserRole } from '@repo/shared-types';
import { DEMO_USER_IDS } from '@repo/shared-types';

/**
 * User slice — session identity for RPC context and RBAC.
 * Clerk-only: no legacy sessionId/refreshToken. Initial state is unauthenticated until Clerk + profile resolve.
 */
export interface UserSlice {
  userRole: UserRole;
  currentUserId: string;
  isSelfManagingOwner: boolean;
  clerkSignedIn: boolean;
  /** True until Clerk has finished loading and (if signed in) backend profile fetch has settled. */
  isAuthPending: boolean;

  setUserRole: (role: UserRole) => void;
  setCurrentUserId: (id: string) => void;
  setAuthUser: (id: string, role: UserRole, isSelfManagingOwner?: boolean) => void;
  setSelfManagingOwner: (value: boolean) => void;
  setClerkSignedIn: (value: boolean) => void;
  setAuthPending: (value: boolean) => void;
}

export const createUserSlice: StateCreator<UserSlice> = (set) => ({
  userRole: UserRole.PROPERTY_MANAGER,
  currentUserId: '',
  isSelfManagingOwner: false,
  clerkSignedIn: false,
  isAuthPending: true,

  setUserRole: (role) => {
    const roleIdMap: Record<string, string> = {
      [UserRole.PROPERTY_MANAGER]: DEMO_USER_IDS.PROPERTY_MANAGER,
      [UserRole.ADMIN]: DEMO_USER_IDS.ADMIN,
      [UserRole.OWNER]: DEMO_USER_IDS.OWNER,
      [UserRole.TENANT]: DEMO_USER_IDS.TENANT,
      [UserRole.VENDOR]: DEMO_USER_IDS.VENDOR,
      [UserRole.INVESTOR]: DEMO_USER_IDS.INVESTOR,
    };
    set({ userRole: role, currentUserId: roleIdMap[role] || '', isSelfManagingOwner: false });
  },

  setCurrentUserId: (id) => set({ currentUserId: id }),
  setAuthUser: (id, role, isSelfManagingOwner = false) =>
    set({ currentUserId: id, userRole: role, isSelfManagingOwner }),
  setSelfManagingOwner: (value) => set({ isSelfManagingOwner: value }),
  setClerkSignedIn: (value) => set({ clerkSignedIn: value }),
  setAuthPending: (value) => set({ isAuthPending: value }),
});
